<template>
  <div>
    <el-dialog
      title="Issue Card"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :width="device === 'mobile' ? '95%' : ''"
      :before-close="handleClose"
      top="5vh"
    >
      <el-form
        :model="issueForm"
        ref="issueForm"
        label-width="150px"
        size="small"
        :rules="issueFormRule"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-form-item label="BankHolder ID" prop="bankholder_id">
          <el-select v-model="issueForm.bankholder_id">
            <el-option
              v-for="item in bankholderList"
              :key="item.id"
              :label="item.label"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Name On Card" prop="card_name">
          <el-input v-model="issueForm.card_name"></el-input>
        </el-form-item>

        <el-form-item label="Customer Name" v-if="customerInfo && customerInfo.kyc.personal">
          <el-input v-model="customerInfo.kyc.personal.name" readonly></el-input>
        </el-form-item>
        <el-form-item label="Business Name" v-if="customerInfo && customerInfo.kyc.company">
          <el-input v-model="customerInfo.kyc.company.name" readonly></el-input>
        </el-form-item>
        <el-form-item label="Director name" v-if="customerInfo && customerInfo.kyc.company">
          <el-input v-model="customerInfo.kyc.director.name" readonly></el-input>
        </el-form-item>
        
        <el-form-item label="Type" prop="card_type">
          <el-select v-model="issueForm.card_type">
            <el-option label="Physical" value="physical"></el-option>
            <el-option label="Virtual" value="virtual"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Address number" prop="address_number">
          <el-input v-model="issueForm.address_number"></el-input>
        </el-form-item>
        <el-form-item label="Street" prop="address_street">
          <el-input v-model="issueForm.address_street"></el-input>
        </el-form-item>
        <el-form-item label="City" prop="address_city">
          <el-input v-model="issueForm.address_city"></el-input>
        </el-form-item>
        <el-form-item label="Refinement" prop="address_refinement">
          <el-input v-model="issueForm.address_refinement"></el-input>
        </el-form-item>
        <el-form-item label="Region" prop="address_region">
          <el-input v-model="issueForm.address_region"></el-input>
        </el-form-item>
        <el-form-item label="Zipcode" prop="address_postal_code">
          <el-input v-model="issueForm.address_postal_code"></el-input>
        </el-form-item>
        <el-form-item label="Country Code" prop="address_iso_country">
          <el-autocomplete
                class="inline-input"
                v-model="issueForm.address_iso_country"
                :fetch-suggestions="querySearchCountrycode"
                @select="selectCountrycode"
                :maxlength="2"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="Delivery Name" prop="card_delivery_name">
          <el-input v-model="issueForm.card_delivery_name"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">Cancel</el-button>
        <el-button
          type="primary"
          :loading="submiting"
          @click="submitIssueCard()"
          >Submit</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cardIssue } from "@/api/card";
import { getUtility } from "@/api/customer";
export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    username() {
      return this.$store.state.user.fullname;
    },
  },
  data() {
    return {
      dialogShow: false,
      submiting: false,
      utility: {},
      bankholderList: [],
      customerInfo: null,
      issueForm: this.model(),
      issueFormRule: {
        bankholder_id: [{required: true, message: "Please select BankholderID", trigger: "blur"}],
        card_name: [{required: true, message: "Please enter Name on Card", trigger: "blur"}],
        card_delivery_name: [{required: true, message: "Please enter Delivery Name", trigger: "blur"}],
        address_number: [{required: true, message: "Please enter Address number", trigger: "blur"}],
        address_street: [{required: true, message: "Please enter Street", trigger: "blur"}],
        address_city: [{required: true, message: "Please enter City", trigger: "blur"}],
        address_refinement: [{required: true, message: "Please enter Refinement", trigger: "blur"}],
        address_region: [{required: true, message: "Please enter Region", trigger: "blur"}],
        address_postal_code: [{required: true, message: "Please enter Zipcode", trigger: "blur"}],
        address_iso_country: [{required: true, message: "Please enter Country Code", trigger: "blur"}],
      },
    };
  },
  methods: {
    getUtility() {
      getUtility().then(({ result, data }) => {
        if (result) {
          this.utility = data;
        }
      });
    },

    model(){
      return {
        bankholder_id: "",
        card_name: "",
        card_type: "physical",
        card_delivery_name: "",
        address_street: "",
        address_number: "",
        address_city: "",
        address_refinement: "",
        address_region: "",
        address_postal_code: "",
        address_iso_country: "",
      }
    },



    converToList(arrayObj){
      let returnArray = [];
    
      arrayObj.forEach(element => {
        let item = {
            id: element['bankholderID'],
            label: `${element['currency'].toUpperCase()} (${element['bankholderID']})`
        }
        
        if(element.currency != 'usd' || element.status != 'closed'){
          returnArray.push(item)
        }
      });

      return returnArray;
    },

    openDialog(customer, bankaccount) {
      
      this.customerInfo = customer;
      this.issueForm = this.model()

      let setInfo = null;
       
      if(this.customerInfo && this.customerInfo.type === 'person'){
        setInfo = this.customerInfo.kyc.personal
      }else{
        setInfo = this.customerInfo.kyc.company
      }

      this.issueForm.address_number = setInfo.addressnumber
      this.issueForm.address_street = setInfo.street
      this.issueForm.address_city = setInfo.city
      this.issueForm.address_refinement = setInfo.refinement
      this.issueForm.address_region = setInfo.region
      this.issueForm.address_postal_code = setInfo.zipcode
      this.issueForm.address_iso_country = setInfo.countrycode
      

      this.bankholderList = this.converToList(bankaccount)
      this.dialogShow = true;

    },

    issueCard(){
      this.submiting = true;
      cardIssue(this.issueForm).then(({ result }) => {
        this.submiting = false;
        if (result) {
          this.dialogShow = false;
          this.$notify({
            title: "Success",
            message: `Issue card successfully`,
            type: "success",
            duration: 2000,
          });
          this.$emit('submited')
        }
      });
    },

    submitIssueCard() {
      
       this.$refs.issueForm.validate((valid) => {
        if (valid) {
          this.issueCard()
        }else{
          console.log("error submit!!");
          return false;
        }
       });
    },
    querySearchCountrycode(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "country_code"))
        : data;
      cb(results);
    },
    selectCountrycode(item) {
      this.issueForm.address_iso_country = item.country_code;
    },
     createFilter(queryString, key) {
      return (item) => {
        return item[key].toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleClose() {
      this.dialogShow = false;
    },
  },
  created(){
    this.getUtility();
  }
};
</script>

<style>
</style>